// extracted by mini-css-extract-plugin
export var quillEditor = "_ib-1";
export var variable = "_ib-0";